import { reduxForm } from 'redux-form';
import Component from './Component';

const initialValues = {
  file: null,
  activateReason: ''
};

const FormNikActivatedBulk = reduxForm({
  form: 'FormNikActivatedBulk',
  initialValues,
  enableReinitialize: true,
})(Component);

export default FormNikActivatedBulk;
